// extracted by mini-css-extract-plugin
module.exports = {"wrapperFilter":"ModalFormBagging_wrapperFilter__CJsz1","filterColumn":"ModalFormBagging_filterColumn__1KfkL","actionFilter":"ModalFormBagging_actionFilter__2ykK6"};